import { Box, Grid, Paper, Tab, Tabs, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const CTScanNav = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [value, setValue] = useState("/ct-scan");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const valid = ["/ct-scan", "/ct-scan/tests", "/ct-scan/patient-records"];
    if (valid.includes(location.pathname)) setValue(location.pathname);
    else setValue("/ct-scan");
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={(e, v) => {
              setValue(v);
              navigate(v);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" },
            }}
          >
            <Tab
              style={{ ...tabStyle, backgroundColor: value === "/ct-scan" ? theme.palette.primary.main : "white", color: value === "/ct-scan" ? "white" : "black" }}
              label={t("ct_scan.dashboard", "Dashboard")}
              value="/ct-scan"
              component={NavLink}
              to="/ct-scan"
            />
            <Tab
              style={{ ...tabStyle, backgroundColor: value === "/ct-scan/tests" ? theme.palette.primary.main : "white", color: value === "/ct-scan/tests" ? "white" : "black" }}
              label={t("ct_scan.ctScanType", "CT Scan Type")}
              value="/ct-scan/tests"
              component={NavLink}
              to="/ct-scan/tests"
            />
            <Tab
              style={{ ...tabStyle, backgroundColor: value === "/ct-scan/patient-records" ? theme.palette.primary.main : "white", color: value === "/ct-scan/patient-records" ? "white" : "black" }}
              label={t("ct_scan.testResult", "Test Result")}
              value="/ct-scan/patient-records"
              component={NavLink}
              to="/ct-scan/patient-records"
            />
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default CTScanNav;

